// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Migration_PreflightColaboradoresResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract de GET /migration/colaboradores/preflight
 * (controllers/migration/colaboradores.php::preflight).
 *
 * Pre-voo da etapa E2: uma linha por colaborador candidato do Zoho, com o grupo
 * alvo, a franquia-casa ja resolvida, os blockers e se ele ja veio. NADA e
 * escrito — nem `migration_runs`, nem `migration_id_map`, nem `migration_errors`,
 * nem um unico usuario no Cognito.
 *
 * `dados` e a LISTA direta (sem chave embrulhando), como no irmao
 * `Migration_PreflightFranquiasResponse` e pelo mesmo motivo: o que existe alem
 * dos colaboradores — total, quantos bloqueados, quantos ja migrados — e
 * derivavel da propria lista, e duplicar isso no wire criaria uma segunda
 * opiniao sobre a mesma verdade.
 *
 * Nenhuma senha viaja aqui, em nenhum campo, por construcao — ver o docblock de
 * Migration_PreflightColaboradorRow.
 */
import type { Migration_PreflightColaboradorRow } from './Migration_PreflightColaboradorRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Migration_PreflightColaboradoresResponseDados = Migration_PreflightColaboradorRow[];

export type Migration_PreflightColaboradoresResponse = ApiResponse<Migration_PreflightColaboradoresResponseDados>;

registerResponseContract('Migration_PreflightColaboradoresResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      zoho_id:            { type: 'string',  required: false },
      nome:               { type: 'string',  required: false },
      email:              { type: 'string',  required: false },
      funcao:             { type: 'string',  required: false },
      grupo_alvo:         { type: 'string',  required: false },
      franquia_casa: {
        type: 'object',
        required: false,
        fields: {
          zoho_id:      { type: 'string',  required: false },
          franchise_id: { type: 'number',  required: false },
          nome:         { type: 'string',  required: false },
        },
      },
      n_franquias_acesso: { type: 'number',  required: false },
      ja_migrado:         { type: 'boolean', required: false },
      blockers: {
        type: 'array',
        required: false,
        items: {
          code:     { type: 'string',  required: false },
          message:  { type: 'string',  required: false },
          severity: { type: 'string',  required: false },
          entity:   { type: 'string',  required: false },
          zoho_id:  { type: 'string',  required: false },
          label:    { type: 'string',  required: false },
        },
      },
    },
  },
})
